var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.551 1.7905C20.1297 1.34419 19.5319 1.08689 18.9157 1.08689H16.9539C16.9618 0.73509 16.967 0.372826 16.967 0H4.31368C4.31368 0.372775 4.31892 0.73509 4.32684 1.08689H2.35181C1.73559 1.08689 1.13784 1.34419 0.716498 1.7905C0.28986 2.23947 0.0686982 2.85375 0.105524 3.47599C0.458407 9.34096 3.49471 13.0216 8.30848 13.5677L7.37626 16.8021C6.26762 16.8021 5.36965 17.6973 5.36965 18.8026V21.0026H15.9137V18.8026C15.9137 17.6973 15.0157 16.8021 13.9071 16.8021L12.9748 13.5677C17.7781 13.0164 20.8118 9.33835 21.162 3.47599C21.1988 2.85642 20.9777 2.24208 20.551 1.7905ZM2.2096 3.34995C2.20698 3.29221 2.23069 3.25283 2.25172 3.23181C2.29122 3.18982 2.33865 3.18982 2.35181 3.18982H4.42693C4.74031 7.31946 5.65407 9.66123 6.54155 10.9844C3.16291 9.57196 2.35706 5.79939 2.2096 3.34995ZM14.7392 10.9765C15.6266 9.65072 16.5378 7.31157 16.8512 3.1872H18.9184C18.9341 3.1872 18.9789 3.1872 19.0184 3.2292C19.0395 3.25022 19.0632 3.2896 19.0606 3.34733C18.9105 5.79678 18.1073 9.55883 14.7392 10.9765Z",
    fill: "#FFB444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldTrophy);
export default __webpack_public_path__ + "static/media/gold_trophy.e4083b2d216202d5a20d0456cfb0a873.svg";
export { ForwardRef as ReactComponent };